<script>
	import Helper from '../../../Models/Helper';
	import {onMount} from 'svelte';

	export let pass = {};

	let validation = {
		valid: false, upper: false, lower: false,
		number: false, special: false, count: false
	};

	function passKeyUp() {
		const v = validation;
		const value = jQuery(pass).val();
		v.upper = /[A-Z]/.test(value);
		v.lower = /[a-z]/.test(value);
		v.number = /[0-9]/.test(value);
		v.special = /[^0-9a-zA-Z]/.test(value);
		v.count = value.length >= 8;
		v.valid = v.upper && v.lower && v.number && v.special && v.count;
		validation = v; /* To trigger a render. */
	}

	onMount(() => {
		const render = () => {
			if (Helper.is(pass)) pass.onkeyup = () => passKeyUp();
			else console.error('Pass element not found.');
		};

		setTimeout(render, 1000);
	});
</script>

<div class="notice compact" class:valid="{validation.valid}">
	<i class="fas fa-{validation.valid ? 'check' : 'info-circle'}"></i> Het wachtwoord moet aan de volgende voorwaarden voldoen:
</div>
<div class="notice compact" class:valid="{validation.upper}">
	<i class="fas fa-{validation.upper ? 'check' : 'times'}"></i> Minimaal 1 hoofdletter.
</div>
<div class="notice compact" class:valid="{validation.lower}">
	<i class="fas fa-{validation.lower ? 'check' : 'times'}"></i> Minimaal 1 letter.
</div>
<div class="notice compact" class:valid="{validation.number}">
	<i class="fas fa-{validation.number ? 'check' : 'times'}"></i> Minimaal 1 nummer.
</div>
<div class="notice compact" class:valid="{validation.special}">
	<i class="fas fa-{validation.special ? 'check' : 'times'}"></i> Minimaal 1 speciaal teken.
</div>
<div class="notice compact" class:valid="{validation.count}">
	<i class="fas fa-{validation.count ? 'check' : 'times'}"></i> Minimaal 8 tekens in totaal.
</div>